import styles from './PickerForm.module.scss';
import { Api } from '../../../../lib/types/apiSpec';
import { PickerFormItem } from './PickerFormTypes';
import { Label } from '../../../common/Label/Label';
import { TRAINING_TYPE_LABEL } from '../../../../lib/constants/labelKeys';

export const renderTeam = (item: Api.TeamBase) => (
  <span className={styles.dialogListTeamItem}>{item.teamPathNames}</span>
);

export const renderLibraryEntry = (item: Api.BaseLibraryEntry) => (
  <span className={styles.trainingItem}>
    <span>{item.name}</span>
    <span className={styles.trainingItemType}>{item.curriculumType}</span>
  </span>
);

const TrainingItem: React.FC<Api.TrainingBase> = ({ type, name }) => {
  return (
    <span className={styles.trainingItem}>
      <span>{name}</span>
      <Label className={styles.trainingItemType} name={TRAINING_TYPE_LABEL(type)} />
    </span>
  );
};

export const renderTraining = (item: Api.TrainingBase) => <TrainingItem {...item} />;

export const teamIdFunction = (item: Api.TeamBase) => item.id;

export const trainingIdFunction = (item: Api.TrainingBase) => item.id;

export const libraryEntryIdFunction = (item: Api.BaseLibraryEntry) => item.id;

const filterItems =
  <T extends Record<string, string | number>>(prop: keyof T) =>
  (phrase: string) =>
  (item: T) => {
    if (!phrase) {
      return true;
    }

    const phrases = phrase
      .trim()
      .split(' ')
      .map(phraseChunk => phraseChunk.toLowerCase());

    const itemChunks = item[prop]
      ?.toString()
      .split(' ')
      .map(itemChunk => itemChunk.toLowerCase());

    return phrases.every(phraseChunk => itemChunks?.some(itemChunk => itemChunk.includes(phraseChunk)));
  };

export const filterTeams = filterItems<Api.TeamBase>('teamPathNames');
export const filterTrainings = filterItems<Api.TrainingBase>('name');
export const filterLibraryEntries = filterItems<Api.BaseLibraryEntry>('name');

export const isApiTraining = (item: PickerFormItem): item is Api.TrainingBase => !!(item as Api.TrainingBase).type;
export const isApiTrainingTeam = (item: PickerFormItem): item is Api.TeamBase => !!(item as any).teamPathNames;
